import { Component, Input, inject } from '@angular/core';
import {TeamMember} from '../../../models/team-member';
import {TeamMemberService} from '../../../services/team-member.service';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {TeamMemberModalComponent} from '../team-member-modal/team-member-modal.component';
import {BehaviorSubject, Observable} from 'rxjs';
import {Mode} from '../../../models/mode';
import {switchMap} from 'rxjs/operators';

@Component({
    selector: 'app-prd-team-members',
    templateUrl: './prd-team-members.component.html',
    standalone: false
})
export class PrdTeamMembersComponent {
    private teamMemberService = inject<TeamMemberService>('TeamMemberService' as any);
    private vwuiModalService = inject(VwuiModalService);

    @Input() refId = 0;
    @Input() mode$: Observable<Mode>|undefined;

    refresh$ = new BehaviorSubject<null>(null);
    teamMembers$ = this.refresh$.pipe(
        switchMap(() => {
            return this.teamMemberService.list(this.refId);
        })
    );

    private modalOpen = false;

    openModal(member?: TeamMember): void {
        if (this.modalOpen) {
            return;
        }

        this.modalOpen = true;
        this.vwuiModalService.open(TeamMemberModalComponent, {
            closeOnBackdropClick: false,
            data: {refId: this.refId, teamMember: member}
        }).afterClosed.subscribe(_ => {
            this.modalOpen = false;
            this.refresh$.next(null);
        });
    }

    async deleteMember(member: TeamMember): Promise<void> {
        if (!window.confirm('Weet u zeker dat u dit teamlid wilt verwijderen?')) {
            return;
        }

        await this.teamMemberService.delete(this.refId, member).toPromise();
        this.refresh$.next(null);
    }
}
